import React from "react";
import useSeo from "../seo/useSeo";

export default function Conditions() {
  useSeo({
    title: "Conditions d’utilisation | pdf-convert.fr",
    description:
      "Conditions d’utilisation du site pdf-convert.fr et de ses outils.",
    canonical: "https://pdf-convert.fr/conditions",
  });

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Conditions d’utilisation</h1>

      <p>
        L’accès et l’utilisation du site <b>pdf-convert.fr</b> impliquent
        l’acceptation pleine et entière des présentes conditions d’utilisation.
      </p>

      <h2>1. Objet du site</h2>
      <p>
        Le site propose des outils gratuits de conversion et de traitement de
        fichiers numériques (PDF, images).
      </p>

      <h2>2. Utilisation</h2>
      <p>
        L’utilisateur s’engage à utiliser le site de manière légale et conforme
        aux lois en vigueur. Toute utilisation abusive ou frauduleuse est
        interdite.
      </p>

      <h2>3. Responsabilité</h2>
      <p>
        Les outils sont fournis « en l’état », sans garantie de disponibilité ou
        d’exactitude. L’éditeur ne pourra être tenu responsable de pertes de
        données ou de dommages liés à l’utilisation du site.
      </p>

      <h2>4. Disponibilité</h2>
      <p>
        L’accès au site peut être interrompu à tout moment pour maintenance ou
        mise à jour.
      </p>

      <h2>5. Modification</h2>
      <p>
        L’éditeur se réserve le droit de modifier à tout moment les présentes
        conditions.
      </p>
    </main>
  );
}
